import { AssessmentType } from "../../../api/main/models/codeOnly/AssessmentType";
import { LaunchAssessmentBase } from "../launch/LaunchAssessmentBase";

/**
 * Launch an assessment session.
 */
export const LaunchAssessment = () => (<LaunchAssessmentBase defaultAssessmentType={AssessmentType.Assessment} />);
